import {jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class Interest {
    @jsonMember
    id: number;
    @jsonMember
    name: string;
}
